import { connect } from 'react-redux'
import { setLightbox } from '../actions'
import ImageMagnifier from '../components/imageMagnifier'

const mapDispatchToProps = dispatch => ({
  openLightbox: elements => dispatch(setLightbox(elements)),
})

export default connect(
  null,
  mapDispatchToProps,
)(ImageMagnifier)



// WEBPACK FOOTER //
// ./src/modules/core/containers/imageMagnifier.js